import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkSession, getSessionUsername } from '../config/authConfig';

// Protected route that only allows access to user 'mhansell'
const MhansellRoute = ({ children }) => {
  const isAuthenticated = checkSession();
  const username = getSessionUsername();
  
  // Redirect to home if not authenticated or not mhansell
  if (!isAuthenticated || username !== 'mhansell') {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default MhansellRoute;
